document.addEventListener( "DOMContentLoaded", function() {
	const sliders = document.querySelectorAll( '.query-loop-slider-wrapper .is-query-loop-slider' );

	if ( !sliders.length ) {
		return;
	}

	function getSliderProperty(obj, property) {
		if ( obj && obj.hasOwnProperty(property) && obj[property] !== null && obj[property] !== undefined) {
			return obj[property];
		}

		return false;
	}

	const initSliders = () => {
		const defaultSettings = {
			pagination: false,
			loop: true,
			rewind: false,
			simulateTouch: true,
			slidesPerView: 2,
			autoHeight: true,
			spaceBetween: 32,
		};

		const breakpoints = {
			md: 768,
			lg: 1024
		}

		if ( typeof Swiper === 'undefined' ) {
			return;
		}

		// Function to randomly select 5 slides and remove the rest
		function keepRandomSlides(container, slidesNodeList, count) {

			const slides = Array.from( slidesNodeList );

			// Shuffle the slides array
			for (let i = slides.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[slides[i], slides[j]] = [slides[j], slides[i]];
			}

			// Select the first 'count' slides after shuffling
			const slidesToKeep = slides.slice(0, count);

			// Remove all slides initially
			container.innerHTML = '';

			// Append the slides to keep back to the container
			slidesToKeep.forEach(slide => container.appendChild(slide));
		}

		sliders.forEach( ( slider, i ) => {
			const slides = slider.querySelectorAll( '.wp-block-post' );

			if ( !slides.length ) {
				console.log( 'found no slider cards' );
				return true;
			}

			const sliderAttrs = JSON.parse(slider.parentElement.getAttribute('data-slider-attrs'));

			if ( !sliderAttrs ){
				console.error( 'found no slider data' );
				return true;
			}

			const container = slider.querySelector( '.wp-block-post-template' );

			if ( sliderAttrs?.orderBy === 'rand' ) {
				keepRandomSlides( container, slides, sliderAttrs?.maxSlides ?? 5 );
			}

			const customSettings = {};

			slider.classList.add( `swiper-${i}` );
			container.classList.remove('is-layout-grid');
			container.classList.add( 'query-loop-swiper-wrapper', 'block-slider__items', 'swiper-wrapper' );

			slides.forEach( slide => slide.classList.add( 'swiper-slide' ) );

			// Arrows navigation.
			const arrows = {
				"sm": getSliderProperty( sliderAttrs, 'smArrows' ),
				"md": getSliderProperty( sliderAttrs, 'mdArrows' ),
				"lg": getSliderProperty( sliderAttrs, 'lgArrows' )
			};

			if ( arrows?.sm || arrows?.md || arrows?.lg ) {

				const navigation = document.createElement( 'div' );
				navigation.classList.add( 'swiper-navigation' );
				navigation.innerHTML = '<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>';
				slider.closest( '.query-loop-slider-wrapper' ).appendChild( navigation );

				setProperty( customSettings, 'navigation', {
					nextEl: '.swiper-' + i + ' + .swiper-navigation .swiper-button-next',
					prevEl: '.swiper-' + i + ' + .swiper-navigation .swiper-button-prev'
				} );
			}

			// Dots pagination per view settings.
			const dots = {
				"sm": getSliderProperty( sliderAttrs, 'smDots' ),
				"md": getSliderProperty( sliderAttrs, 'mdDots' ),
				"lg": getSliderProperty( sliderAttrs, 'lgDots' )
			};

			if ( dots?.sm || dots?.md || dots?.lg ){

				const dotsConfig = {
					el: ".swiper-pagination",
					clickable: true,
					renderBullet: ( index, className ) => '<span class="' + className + '"></span>'
				};

				if ( dots?.sm ) {
					setProperty( customSettings, 'pagination', dotsConfig );
				}
				if ( dots?.md ) {
					setProperty( customSettings, `breakpoints.${breakpoints.md}.pagination`, dotsConfig );
				}
				if ( dots?.lg ) {
					setProperty( customSettings, `breakpoints.${breakpoints.lg}.pagination`, dotsConfig );
				}

				const pagination = document.createElement('div');
				pagination.classList.add('swiper-pagination');
				slider.closest('.query-loop-slider-wrapper').appendChild(pagination);
			}


			// Slides per view settings.
			const dataItems = {
				"sm": getSliderProperty(sliderAttrs, 'smItemsDisplayed') || 1.2,
				"md": getSliderProperty(sliderAttrs, 'mdItemsDisplayed') || 1.6,
				"lg": getSliderProperty(sliderAttrs, 'lgItemsDisplayed') || 3
			};

			if ( dataItems?.sm ) {
				setProperty( customSettings, 'slidesPerView', dataItems.sm );
			}
			if ( dataItems?.md ) {
				setProperty( customSettings, `breakpoints.${breakpoints.md}.slidesPerView`, dataItems.md );
			}
			if ( dataItems?.lg ) {
				setProperty( customSettings, `breakpoints.${breakpoints.lg}.slidesPerView`, dataItems.lg );
			}

			// Gutter settings.
			const dataGutter = {
				"sm": getSliderProperty(sliderAttrs, 'smGutter') || 16,
				"md": getSliderProperty(sliderAttrs, 'mdGutter') || 16,
				"lg": getSliderProperty(sliderAttrs, 'lgGutter') || 32
			};

			if ( dataGutter?.sm ) {
				setProperty( customSettings, 'spaceBetween', dataGutter.sm );
			}
			if ( dataGutter?.md ) {
				setProperty( customSettings, `breakpoints.${breakpoints.md}.spaceBetween`, dataGutter.md );
			}
			if ( dataGutter?.lg ) {
				setProperty( customSettings, `breakpoints.${breakpoints.lg}.spaceBetween`, dataGutter.lg );
			}

			setProperty( customSettings, `loop`, getSliderProperty( sliderAttrs, 'loop' ) || false );

			const swiper = new Swiper( slider, {
				...defaultSettings,
				...customSettings
			} );
		} );
	}

	const setProperty = ( obj, path, value ) => {
		var schema = obj;
		var pList = path.split( '.' );
		var len = pList.length;
		for ( var i = 0; i < len - 1; i ++ ) {
			var elem = pList[ i ];
			if ( !schema[ elem ] ) schema[ elem ] = {}
			schema = schema[ elem ];
		}

		schema[ pList[ len - 1 ] ] = value;
	}

	if ( typeof Swiper === 'undefined' ) {
		// Load Swiper script and styles dynamically
		var scriptUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
		var styleUrl = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

		var link = document.createElement( 'link' );
		link.rel = 'stylesheet';
		link.href = styleUrl;
		document.head.appendChild( link );

		var script = document.createElement( 'script' );
		script.src = scriptUrl;
		script.onload = initSliders;
		document.head.appendChild( script );
	} else {
		initSliders();
	}
} );
